/**
 * AudioWorklet processor for low-cost pink noise.
 *
 * The processor is shipped to the audio thread via a Blob URL so the
 * Vite dev server does not need a separate worker entry. The Voss-McCartney
 * approximation here is the standard small-state pink-noise generator.
 */

export const PINK_NOISE_PROCESSOR_NAME = "pink-noise-processor";

const PROCESSOR_SOURCE = `
class PinkNoiseProcessor extends AudioWorkletProcessor {
  constructor() {
    super();
    this.b0 = 0;
    this.b1 = 0;
    this.b2 = 0;
    this.b3 = 0;
    this.b4 = 0;
    this.b5 = 0;
    this.b6 = 0;
  }

  process(_inputs, outputs) {
    const output = outputs[0];
    for (let channel = 0; channel < output.length; channel += 1) {
      const samples = output[channel];
      for (let i = 0; i < samples.length; i += 1) {
        const white = Math.random() * 2 - 1;
        this.b0 = 0.99886 * this.b0 + white * 0.0555179;
        this.b1 = 0.99332 * this.b1 + white * 0.0750759;
        this.b2 = 0.96900 * this.b2 + white * 0.1538520;
        this.b3 = 0.86650 * this.b3 + white * 0.3104856;
        this.b4 = 0.55000 * this.b4 + white * 0.5329522;
        this.b5 = -0.7616 * this.b5 - white * 0.0168980;
        const pink = (
          this.b0 + this.b1 + this.b2 + this.b3 + this.b4 + this.b5 + this.b6 + white * 0.5362
        ) * 0.11;
        this.b6 = white * 0.115926;
        samples[i] = pink;
      }
    }
    return true;
  }
}

registerProcessor("${PINK_NOISE_PROCESSOR_NAME}", PinkNoiseProcessor);
`;

let cachedUrl: string | null = null;

/**
 * Return a stable Blob URL containing the pink-noise processor source.
 * The URL is created once per page session to avoid repeatedly registering
 * the same module on the AudioWorklet.
 */
export function pinkNoiseModuleUrl(): string {
  if (cachedUrl) return cachedUrl;
  const blob = new Blob([PROCESSOR_SOURCE], { type: "application/javascript" });
  cachedUrl = URL.createObjectURL(blob);
  return cachedUrl;
}
